import React, { createContext, useContext, useReducer } from 'react';

import { userStoreReducer } from './reducer';
import { initinalState } from './initialState';
import { userStateContext, UserStoreProviderProps } from './types';

const UserStoreContext = createContext<userStateContext>({
	state: initinalState,
	dispatch: null,
});

const useUserStoreContext = (): userStateContext => useContext(UserStoreContext);

function UserStoreProvider(props: UserStoreProviderProps): JSX.Element {
	const [state, dispatch] = useReducer(userStoreReducer, initinalState);

	return (
		<UserStoreContext.Provider value={{ state, dispatch }}>
			{props.children}
		</UserStoreContext.Provider>
	);
}

export {UserStoreProvider, useUserStoreContext};
